import React, { memo, useEffect, useState } from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import axios, { Axios } from 'axios';
import { useParams } from '../../../services/router';
import SubTitle from '../../../components/Content/SubTitle';
import styles from './styles';
import { makeSelectButtons } from '../../../providers/ButtonsProvider/selectors';
import Paragraph from '../../../components/Content/Paragraph';
import API from '../../../config/api';
import HtmlParser from '../../../components/HtmlParser';
import { getImageFromS3 } from '../../../utils/s3Helper';

function Document({ buttons }) {
	const [url, setUrl] = useState('');
	const [hasError, setHasError] = useState(false);
	const { documentId } = useParams();
	const { field2, field7, field3 } = buttons.find((button) => button.id === documentId);
	const title = field2;
	const secureDocumentId = Number(field7);
	const source = {
		uri: `https://sb-all-images-data.s3.ca-central-1.amazonaws.com/location-data/${secureDocumentId}.pdf`,
		cache: true,
		headers: {
			"accept": "application/pdf",
			"Content-Type": "application/pdf",
			"Access-Control-Allow-Origin": '*'
		}
	};

	async function loadPdf() {
		try {
			fetch(source.uri)
				.then(response => response.blob())
				.then(data => {
					const dataUrl = URL.createObjectURL(data);
					setUrl(dataUrl);
				})
				.catch(error => console.error('Error:', error));
		} catch (error) {
			setHasError(true);
		}
	}

	useEffect(() => {
		loadPdf();
	}, [secureDocumentId]);

	return (
		<>
			<View style={styles.heading}>
				<SubTitle title={title} />
				{(field3 ? field3.length > 0 : false) && (
					<HtmlParser noMargin html={field3} />
				)}
				{hasError && (
					<Paragraph>Unfortunately, there is no document associated with this button.</Paragraph>
				)}
			</View>
			<View style={styles.doc}>
				<iframe
					src={url}
					title="PDF Viewer"
					style={{ width: '100%', height: '100vh', border: 'none' }}
				/>
			</View>
		</>
	);
}

const mapStateToProps = createStructuredSelector({
	buttons: makeSelectButtons(),
});

const withConnect = connect(
	mapStateToProps,
);

export default compose(
	withConnect,
	memo,
)(Document);
